import { FC } from 'react'

import { t } from 'translations'

const AvailabilityRangeSummary: FC<{ range: MData.Day['availabilities'][number] }> = ({ range }) => {
  return (
    <span>
      {range.type === 'PREFERRED' ? <span className="text-warning"> {t('components.availabilities.PREFER_TEXT')}</span> : null}
      {range.type === 'UNAVAILABLE' ? <span className="text-danger"> {t('components.availabilities.UNAVAILABLE_TEXT')}</span> : null}
      {range.type === 'AVAILABLE' ? <span className="text-success"> {t('components.availabilities.AVAILABLE_TEXT')}</span> : null}{' '}
      {t('components.availabilities.FROM_TIME')} {range.start}
      {t('components.availabilities.TO_TIME')}
      {range.end}
    </span>
  )
}

export default AvailabilityRangeSummary
